import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm: FormGroup;
  loading = false;
  successMessage = '';
  errorMessage = '';
  emailSent = false;

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    private router: Router
  ) {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {}

  onSubmit(): void {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const email = this.forgotForm.value.email;

    this.api.forgotPassword(email).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.emailSent = true;
        this.successMessage = res.message || 'Se o email estiver cadastrado, você receberá um link para redefinir sua senha.';
      },
      error: (err: any) => {
        this.loading = false;
        this.errorMessage = err.error?.message || 'Erro ao processar solicitação. Tente novamente.';
      }
    });
  }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }

  get f() { return this.forgotForm.controls; }
}
